<template>
  <favorite-card
    @click.native="favoriteClicked"
    :url="strategyUrl"
    :saved-time="created">
    <div class="strategy-card-body">
      <remove-favorite-btn
        class="show-on-hover"
        :favoriteid="strategy.uuid"
        :type="resourceType" />
      <div class="row">
        <div class="col-md-3">
          <IKImageS3Wrapper
            class="strategy-image"
            :aws-url="strategy.image_url"
            :alt="strategy.title"
            :transformation="[{w: 150, q: 80}]"
          />
        </div>
        <div class="col-md-9">
          <h4>{{ strategy.title }}</h4>
          <p class="text-muted">{{ strategy.description }}</p>
        </div>
      </div>
    </div>
  </favorite-card>
</template>

<script>
import IKImageS3Wrapper from '@/imagekit/IKImageS3Wrapper'
import FavoriteCard from '@/components/favorites/FavoriteCard'
import RemoveFavoriteBtn from './RemoveFavoriteBtn'

export default {
  name: 'StrategyDisplayCard',
  components: {
    RemoveFavoriteBtn,
    FavoriteCard,
    IKImageS3Wrapper
  },
  data() {
    return {
      resourceType: 'strategy'
    }
  },
  props: {
    strategy: {
      type: Object,
      required: true
    },
    created: {
      type: String,
      required: true
    }
  },
  computed: {
    strategyUrl() {
      return {
        name: 'StrategyDetailPage',
        params: {
          slugOrUuid: this.strategy.slug
        }
      }
    }
  },
  methods: {
    favoriteClicked: function() {
      this.$sendEvent('Clicked Favorite Strategy', {
        strategy_uuid: this.strategy.content_uuid
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.strategy-card-body {
  overflow: hidden;
  height: 130px;
  padding: 20px;
  line-height: 20px;
  padding-bottom: 0px;
  margin-bottom: 12px;

  .remove-favorite-btn {
    visibility: hidden;
  }
  &:hover {
    .remove-favorite-btn {
      visibility: visible;
    }
    h4 {
      color: @link-hover-color;
    }
  }
  .strategy-image {
    max-width: 100%;
    height: auto;
  }
  h4 {
    font-weight: bold;
    color: @link-color;
    margin-top: 0;
    margin-bottom: 8px;
  }
  .text-muted {
    color: #aaa;
  }
}
</style>
